import { useState } from 'react'

export function SignIn({ onSignIn }: { onSignIn: (email: string, password: string) => Promise<string | null> }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function submit() {
    setBusy(true)
    setError(null)
    setError(await onSignIn(email, password))
    setBusy(false)
  }

  return (
    <div className="gate">
      <form
        className="gate-box"
        onSubmit={e => { e.preventDefault(); void submit() }}
      >
        <h1>Admin</h1>
        <p className="dim">Sign in with your schnauzelist account.</p>
        <label>
          Email
          <input type="email" autoComplete="username" autoFocus value={email}
                 onChange={e => setEmail(e.currentTarget.value)} />
        </label>
        <label>
          Password
          <input type="password" autoComplete="current-password" value={password}
                 onChange={e => setPassword(e.currentTarget.value)} />
        </label>
        <button type="submit" className="btn btn-primary" disabled={busy || !email || !password}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
        {error && <p className="err">{error}</p>}
      </form>
    </div>
  )
}
